'use client';

import { useCallback, useState } from 'react';

const useHeaderCart = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const closeCart = useCallback(() => {
    setIsCartOpen(false);
  }, []);

  const openCart = useCallback(() => {
    setIsCartOpen(true);
  }, []);

  return {
    closeCart,
    isCartOpen,
    openCart,
  };
};

export default useHeaderCart;
